export const SYSNAME_USER_DEFINED = 'USER_DEFINED';
export const SYSNAME_DEFAULT = 'DEFAULT';
export const SYSNAME_TEMPLATE = 'TEMPLATE';
export const SYSNAME_TEMPLATE_DEFAULT = 'TEMPLATE_DEFAULT';
export const SYSNAME_SYSTEM = 'SYSTEM';

export const SYSNAME_TYPE = {
    IO: 'INPUT/OUTPUT',
    BIOMETRIC: "BIOMETRIC",
    IMPROX_READER: "IMPROX_READER",
    EL_LOCKS_EXIT: "EL_LOCKS_EXIT",
    EL_LOCKS_ENTRY: "EL_LOCKS_ENTRY",
    APERIO: "APERIO",
    LIFT_ELEVATOR: "LIFT_ELEVATOR"
}

/**
 * This constant provides the ID's
 * of Profiles that represent the User Roles.
 *
 * These are static and can be referenced in checks.
*/
export const ROLES = {
    ID_SYSTEM_OWNER: 62,
    ID_SITE_ADMIN: 63,
    ID_INSTALLER: 64,
    ID_REPORTS: 65,
    ID_RECEPTION: 66,
    ID_GUARD: 67
}

export const isAdminOrAbove = (roleId) => {
    return (roleId == ROLES.ID_SYSTEM_OWNER || roleId == ROLES.ID_SITE_ADMIN);
}

export const isSystemOwner = (roleId) => {
    return (roleId == ROLES.ID_SYSTEM_OWNER);
}

export const getProfileTypeBySysname = (profileSysname) => {

    if (profileSysname === SYSNAME_SYSTEM) {
        return 'System';
    }
    else if (profileSysname === SYSNAME_TEMPLATE_DEFAULT) {
        return 'Template Default';
    }
    else if (profileSysname === SYSNAME_TEMPLATE) {
        return 'Template';
    }
    else if (profileSysname === SYSNAME_USER_DEFINED) {
        return 'User Defined';
    }
    else {
        return 'Default';
    }
}

/**
 * This constant provides the ID's
 * of Profiles that represent the Enrolment Categories.
 *
 * Note: These are not user-defined categories.
 * They are static and can be referenced in checks.
*/
export const CATEGORIES = {
    ID_SYSTEM: 8,
    ID_DEFAULT_TEMPLATE: 9
}

export const SUB_TYPES = {
    IMPRO_BIO: "0", // Not a database type
    ASSETS: "2",
    IDEMIA: "3",
    CONTROL_ID: "4",
    POLICY_USER: "7",
    HIK_VISION: "8",
    POLICY_SOFTWARE: "9",
    HID_AMICO: "10",
}

export const IDEMIA_SETTINGS = {
    WIEGAND: "WIEGAND",
    COMMS: "COMMS",
    THREAT_LEVEL: "THREAT_LEVEL",
    ADVANCED: "ADVANCED",
    TIME_AND_ATTENDANCE: "TIME_AND_ATTENDANCE",
}

export const CONTROL_ID_SETTINGS = {
    WIEGAND: "WIEGAND",
    IDENTIFICATION: "IDENTIFICATION",
    FACE_SETTINGS: "FACE_SETTINGS",
    OSDP:"OSDP",
    TIME_AND_ATTENDANCE: "TIME_AND_ATTENDANCE",
}
export const HIK_VISION_SETTINGS = {
    WIEGAND: "WIEGAND",
    COMMS: "COMMS",
    THERMAL_SETTINGS: "THERMAL_SETTINGS",
    AUTHENTICATION_SETTINGS:"AUTHENTICATION_SETTINGS"
}

export const PRESET_TYPES = {
    CONTROLLER: "CONTROLLER",
    BIOMETRIC: "BIOMETRIC",
    READER: "READER",
    IOMODULE: "IOMODULE",
    LOCK: "LOCK",
    LOCKER: "LOCKER",
    TYPE_READER: 1,
    TYPE_CONTROLLER: 2,
    TYPE_CATEGORY: 3,
    TYPE_DASHBOARD: 8,
    TYPE_BIOMETRIC: 9,
    TYPE_ROLE: 10,
    TYPE_LOCK: 11,
    TYPE_LOCKER: 12,
}

export const PRESET_SYSNAME_TYPE = {
    EL_LOCKS_ENTRY: "EL_LOCKS_ENTRY",
    EL_LOCKS_EXIT: "EL_LOCKS_EXIT",
    APERIO: "APERIO"
}

export const DEVICE = "DEVICE";
export const RELEASE_LOCKERS_NOW = 'RELEASE_LOCKERS_NOW'
